import styled from '@emotion/styled';

export const Price = styled.div`
  text-align: center;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textDark};
  position: absolute;
  right: 25%;
`;

export const PackingText = styled.p`
  margin-left: 25%;
`;
